<template>
  <div style="width: 100%">
    <p class="col-form-label">{{ $t('companies.service_area_radius_note') }}</p>

    <form-location-field
      ref="address"
      :field="locationField"
      :layout="layout"
      :model="model"
    />

    <form-number-field
      :field="radiusField"
      :layout="layout"
      :model="model"
      class="radius-input"
    />

    <div class="row">
      <div class="col-sm-12 text-center">{{ radiusValue }} km</div>
    </div>
  </div>
</template>

<script>
import { Field } from 'stylemix-base'
import { get } from 'lodash-es'

export default {
  name: 'FormServiceAreaRadius',

  props: {
    field: {
      type: Field,
      default: null,
    },
    model: {
      type: Object,
      default: null,
    },
    layout: {
      type: String,
      default: 'vertical',
    },
  },

  data() {
    return {
      radiusShape: null,
      locationField: null,
      radiusField: null,
    }
  },

  computed: {
    radiusValue() {
      return get(this.model, `${this.field.attribute}.radius`)
    },
  },

  created() {
    this.locationField = new Field({
      attribute: `${this.field.attribute}.center`,
      errors: this.field.errors,
      withMap: true,
      types: null,
    })
    this.radiusField = new Field({
      attribute: `${this.field.attribute}.radius`,
      errors: this.field.errors,
      initialValue: 0,
      max: this.field.max,
      min: 0,
      range: true,
    })
  },

  mounted() {
    this.$watch(`model.${this.field.attribute}.radius`, this.updateRadiusShape)
    this.$watch(
      `model.${this.field.attribute}.center.latlng`,
      this.updateRadiusShapeCenter,
    )

    let unwatch = this.$watch('$refs.address.googleLoaded', () => {
      this.$nextTick(() => {
        this.updateRadiusShape(
          get(this.model, `${this.field.attribute}.radius`),
        )
        unwatch()
      })
    })
  },

  methods: {
    updateRadiusShape(value) {
      this.createRadiusShape()

      if (!this.radiusShape) {
        return
      }

      if (value > 0) {
        this.radiusShape.setRadius(value * 1000)
        this.radiusShape.setMap(this.$refs.address.map)
        this.$refs.address.map.fitBounds(this.radiusShape.getBounds())
      } else {
        this.radiusShape.setMap(null)
      }
    },

    updateRadiusShapeCenter(newValue) {
      if (!newValue) {
        return
      }
      this.createRadiusShape()

      if (!this.radiusShape) {
        /* eslint-disable-next-line no-console */
        console.warn('It seems Google API not loaded')
        return
      }

      this.radiusShape.setCenter(this.createLatLng(newValue))
    },

    createRadiusShape() {
      if (!this.radiusShape && window.google) {
        this.radiusShape = new window.google.maps.Circle({
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35,
          center: new window.google.maps.LatLng(
            this.createLatLng(
              get(this.model, `${this.field.attribute}.center.latlng`),
            ),
          ),
          editable: false,
        })
      }
    },

    createLatLng(latlng) {
      if (!latlng) {
        return
      }
      latlng = latlng.split(',')

      return {
        lat: Number.parseFloat(latlng[0]),
        lng: Number.parseFloat(latlng[1]),
      }
    },
  },
}
</script>
<style scoped>
.radius-input {
  margin-bottom: 0;
}
</style>
